export default __webpack_public_path__ + "static/media/matkailuauto(2).4078de75.webp";